// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"505":"612f6462","991":"042d8add"}[chunkId] + ".chunk.css";
};